module.exports = __webpack_public_path__ + "img/wallet-gray.d5633cda.svg";